import React from 'react';
import SummaryCard from './SummaryCard';

function DisclaimersAppendix() {
    const disclaimers = [
        {
            title: "Investment Risk",
            content: "All investments are subject to market risk. The value of investments and the income from them can go down as well as up, and you may not get back the amount originally invested. Past performance is not a reliable indicator of future performance."
        },
        {
            title: "Not Tax or Legal Advice",
            content: "This financial plan is not intended to provide tax or legal advice. Please consult with qualified tax and legal professionals before making any financial decisions that could impact your tax situation or legal standing."
        },
        {
            title: "Future Projections",
            content: "The projections or other information regarding the likelihood of various investment outcomes are hypothetical in nature, do not reflect actual investment results, and are not guarantees of future results."
        },
        {
            title: "Insurance Products",
            content: "Insurance product recommendations are based on information provided by you and our understanding of your needs. Please read all policy documents carefully before purchasing any insurance product."
        }
    ];

    return (
        <SummaryCard title="Disclaimers and Appendices">
            <div className="space-y-6">
                {disclaimers.map((disclaimer, idx) => (
                    <div key={disclaimer.title}>
                        <h4 className="content-text font-medium text-gray-900 mb-3">
                            {disclaimer.title}
                        </h4>
                        <p className="content-text text-gray-600 leading-relaxed">
                            {disclaimer.content}
                        </p>

                        {/* Separator for all but last item */}
                        {idx < disclaimers.length - 1 && (
                            <div className="border-b border-gray-200 mt-6"></div>
                        )}
                    </div>
                ))}
            </div>
        </SummaryCard>
    );
}

export default DisclaimersAppendix;